import { Link as RouterLink } from '@takeshape/redux-little-router';
import React from 'react';
import styled from 'styled-components';
import type { useLink } from './link-hook.js';

export const StyledLink = styled(RouterLink)`
  color: ${({ theme }): string => theme.palette.primary.main};

  &:visited {
    color: ${({ theme }): string => theme.palette.primary.main};
  }
`;

export type LinkProps = ReturnType<typeof useLink>;

/** Provides a component that routes to the provided `href` using `redux-little-router`.
 *  If the `href` contains the `{projectPath}` and/or `{branchPath}` pattern and necessary data,
 *  the component will replace them in the provided `href`.
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>((props: LinkProps, ref: any): JSX.Element => {
  const { styled, ...rest } = props;
  const Component = styled ? StyledLink : RouterLink;
  return <Component {...rest} ref={ref} />;
});
